import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawaySessions = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/productivity-host/briefs/giveaways/sessions' });

  return data;
};

export default getGiveawaySessions;
